interface Names {
  fullName?: string;
  firstName?: string;
  lastName?: string;
}

export const extractNamesByFullName = (fullName: string | undefined): Names => {
  const [firstName, lastName] = fullName?.split(/\s+(.*)/) || [];
  return {
    fullName: fullName || '',
    firstName: firstName || '',
    lastName: lastName || '',
  };
};
